import { c as _c } from "react/compiler-runtime";
import { useField } from 'formik';
import { useContext, useState } from 'react';
import useSWR from 'swr';
import APIMethodKeys from '../../../../../client/APIMethodKeys';
import { Div } from '../../../../common/helpers/StyledUtils';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import source_configuration_form_props from '../Forms/source_configuration';
import RadioCardsInput from '../../../../common/Form/Fields/RadioCardsInput';
import SelectInput from '../../../../common/Form/Fields/SelectInput';
import { DashboardContext } from '../../DashboardContext';
import { IconName } from '../../../../common/base/Icon';
const SourceSection = () => {
  const $ = _c(23);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    source_types
  } = useContext(DashboardContext);
  const [t0] = useField("source_use");
  const {
    value: use
  } = t0;
  const [search_term, setSearchTerm] = useState("");
  let filters;
  let t1;
  let t2;
  if ($[0] !== search_term) {
    filters = {
      limit: 100,
      name: search_term ? {
        contains: search_term
      } : undefined
    };
    t1 = useSWR;
    t2 = APIMethodKeys.sources.list(filters);
    $[0] = search_term;
    $[1] = filters;
    $[2] = t1;
    $[3] = t2;
  } else {
    filters = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  let t3;
  if ($[4] !== HookdeckAPI.sources || $[5] !== filters) {
    t3 = () => HookdeckAPI.sources.list(filters);
    $[4] = HookdeckAPI.sources;
    $[5] = filters;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: sources,
    isValidating
  } = t1(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      b: 6
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      value: "new",
      label: "Create new source"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !sources?.models.length;
  let t7;
  if ($[9] !== t6) {
    t7 = <RadioCardsInput m={t4} name="source_use" options={[t5, {
      value: "select",
      label: "Re-use existing source",
      disabled: t6
    }]} />;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== isValidating || $[12] !== search_term || $[13] !== source_types || $[14] !== sources?.models || $[15] !== use) {
    t8 = use === "select" && <SelectInput name="source_id" label="Source" required={true} search={true} placeholder="Select..." search_placeholder="Find a source..." separator={false} sublte_error={true} options={sources?.models.map(source => ({
      value: source.id,
      label: source.name,
      icon: (source_types?.[source.type || "WEBHOOK"]?.icon || "source") as IconName
    })) || []} width={100} block={true} search_term={search_term} setSearchTerm={setSearchTerm} search_is_loading={isValidating} />;
    $[11] = isValidating;
    $[12] = search_term;
    $[13] = source_types;
    $[14] = sources?.models;
    $[15] = use;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== use) {
    t9 = use === "new" && <Div m={{
      t: 6
    }}><source_configuration_form_props.Fields prefix="source" /></Div>;
    $[17] = use;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t8 || $[21] !== t9) {
    t10 = <>{t7}{t8}{t9}</>;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
};
export default SourceSection;